var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPatientMonitorOffline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 66,
    viewBox: "0 0 104 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_65_70)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.3197 66.0109L44.3197 84.288",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.4113,
    y: 25,
    width: 49.2999,
    height: 38.6399,
    rx: 3,
    stroke: "white",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6334 44.916H72.2245C72.4123 44.916 72.5842 44.8108 72.6697 44.6437L75.8193 38.4858C76.0176 38.0981 76.5822 38.1315 76.7334 38.5399L81.1099 50.3613C81.2444 50.7248 81.7234 50.8036 81.9673 50.5024L86.4915 44.916",
    stroke: "black",
    strokeWidth: 7,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6334 39.15H72.2245C72.4123 39.15 72.5842 39.0448 72.6697 38.8776L75.8193 32.7197C76.0176 32.3321 76.5822 32.3655 76.7334 32.7738L81.1099 44.5953C81.2444 44.9588 81.7234 45.0376 81.9673 44.7364L86.4915 39.15",
    stroke: "black",
    strokeWidth: 7,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0316 48.3959H45.1063C45.3155 48.3959 45.5025 48.2657 45.5752 48.0695L49.983 36.1633C50.1525 35.7055 50.8103 35.737 50.9353 36.2089L55.6513 54.015C55.7739 54.4777 56.4141 54.5203 56.5968 54.0778L61.4031 42.4363C61.4804 42.2492 61.6628 42.1271 61.8653 42.1271H72.2246C72.4123 42.1271 72.5842 42.022 72.6697 41.8548L75.8194 35.6969C76.0176 35.3093 76.5823 35.3427 76.7334 35.751L81.1099 47.5725C81.2445 47.9359 81.7235 48.0147 81.9674 47.7136L86.4916 42.1271",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_65_70)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_65_70)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 76.5,
    cy: 27.5,
    r: 22,
    fill: "#AD0606"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.5,
    cy: 27.5,
    r: 20,
    stroke: "white",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_65_70)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_b_65_70)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 76.5,
    cy: 27.5,
    r: 24.5,
    stroke: "black",
    strokeWidth: 6
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M67.1744 17.0408C67.101 16.962 67.0125 16.8988 66.9141 16.855C66.8157 16.8112 66.7095 16.7876 66.6018 16.7857C66.4941 16.7838 66.3871 16.8036 66.2872 16.8439C66.1874 16.8843 66.0966 16.9443 66.0205 17.0205C65.9443 17.0966 65.8843 17.1874 65.8439 17.2872C65.8036 17.3871 65.7838 17.4941 65.7857 17.6018C65.7876 17.7095 65.8112 17.8157 65.855 17.9141C65.8988 18.0125 65.962 18.101 66.0408 18.1744L69.6384 21.7731C68.8523 22.2748 68.1233 22.8608 67.4643 23.5206C66.9402 24.0436 66.4333 24.6638 65.9735 25.328C65.9118 25.4145 65.868 25.5124 65.8445 25.616C65.821 25.7196 65.8183 25.8268 65.8366 25.9314C65.8549 26.0361 65.8938 26.136 65.951 26.2255C66.0083 26.315 66.0827 26.3922 66.17 26.4527C66.2574 26.5132 66.3558 26.5557 66.4597 26.5779C66.5636 26.6 66.6709 26.6012 66.7753 26.5816C66.8797 26.5619 66.9791 26.5217 67.0678 26.4633C67.1565 26.4048 67.2328 26.3294 67.2921 26.2413C67.6995 25.6531 68.1476 25.1055 68.5989 24.6542C69.2595 23.9926 70.0003 23.4163 70.8041 22.9388L72.5067 24.6414C71.7492 25.0438 71.0561 25.5571 70.4502 26.1643C69.7978 26.8166 69.2641 27.5545 68.8545 28.363C68.7585 28.5529 68.7419 28.7732 68.8083 28.9754C68.8747 29.1775 69.0186 29.345 69.2085 29.441C69.3984 29.5371 69.6187 29.5537 69.8208 29.4873C70.023 29.4209 70.1905 29.277 70.2865 29.0871C70.6213 28.4254 71.0596 27.8214 71.5848 27.2979C72.196 26.6854 72.9154 26.1916 73.7066 25.8413L75.7706 27.9053C74.6054 28.0712 73.5258 28.6118 72.6949 29.4453C72.2153 29.9294 71.8305 30.4988 71.5602 31.1244C71.4749 31.3192 71.4704 31.54 71.5478 31.7382C71.6252 31.9363 71.7782 32.0956 71.973 32.181C72.1679 32.2663 72.3887 32.2708 72.5868 32.1934C72.785 32.116 72.9443 31.963 73.0297 31.7682C73.2275 31.3169 73.497 30.9126 73.8285 30.5811C74.2906 30.1182 74.8631 29.7811 75.492 29.6016C76.1209 29.4221 76.7851 29.4062 77.4219 29.5555L85.8245 37.9592C85.9757 38.1054 86.1783 38.1863 86.3886 38.1846C86.5989 38.1828 86.8001 38.0986 86.9489 37.9499C87.0977 37.8013 87.1821 37.6002 87.184 37.3899C87.186 37.1796 87.1052 36.9769 86.9592 36.8256L67.1744 17.0408ZM76.0551 23.6521L77.7491 25.3461C79.1743 25.5919 80.4881 26.2738 81.5093 27.2979C82.0336 27.8305 82.4726 28.4409 82.8108 29.1074C82.9106 29.2915 83.0784 29.4292 83.2785 29.4912C83.4785 29.5532 83.6948 29.5345 83.8812 29.4392C84.0677 29.3438 84.2094 29.1793 84.2761 28.9808C84.3429 28.7823 84.3294 28.5656 84.2385 28.3769C83.824 27.5611 83.2858 26.8144 82.6429 26.1632C81.7845 25.303 80.7536 24.6344 79.6181 24.2016C78.4826 23.7688 77.2683 23.5815 76.0551 23.6521ZM72.743 20.3401L74.0542 21.6501C76.2352 21.1603 78.5131 21.3365 80.5929 22.1558C82.6727 22.9751 84.4587 24.3998 85.7197 26.2455C85.8405 26.4207 86.026 26.5407 86.2353 26.5791C86.4445 26.6175 86.6605 26.5712 86.8356 26.4503C87.0108 26.3295 87.1308 26.1441 87.1692 25.9348C87.2076 25.7255 87.1613 25.5095 87.0404 25.3344C85.5013 23.0861 83.2838 21.3888 80.7116 20.4903C78.1394 19.5918 75.3473 19.5392 72.743 20.3401ZM77.6336 32.2473C77.7826 32.3962 77.9008 32.573 77.9815 32.7677C78.0622 32.9623 78.1037 33.1709 78.1038 33.3816C78.1038 33.5923 78.0624 33.8009 77.9818 33.9955C77.9012 34.1902 77.7831 34.3671 77.6341 34.5161C77.4852 34.6651 77.3084 34.7833 77.1138 34.864C76.9191 34.9447 76.7105 34.9862 76.4998 34.9863C76.2892 34.9863 76.0805 34.9449 75.8859 34.8643C75.6912 34.7837 75.5143 34.6656 75.3653 34.5166C75.0644 34.2158 74.8953 33.8078 74.8952 33.3823C74.8951 32.9568 75.064 32.5487 75.3648 32.2478C75.6656 31.9469 76.0736 31.7777 76.4991 31.7776C76.9246 31.7775 77.3327 31.9465 77.6336 32.2473Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_65_70",
    x: 44.5,
    y: -4.5,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_65_70"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_65_70",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_65_70",
    x: 24.5,
    y: -24.5,
    width: 104,
    height: 104,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_65_70"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_65_70",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_65_70",
    x: 39,
    y: -10,
    width: 75,
    height: 75,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_65_70"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_65_70",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_b_65_70",
    x: 19,
    y: -30,
    width: 115,
    height: 115,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_65_70"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_65_70",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_65_70"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 66,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientMonitorOffline);
export default __webpack_public_path__ + "static/media/patient-monitor-offline.dbc8c8524dce8da044e86a2793250283.svg";
export { ForwardRef as ReactComponent };